import AppliedFlowDescription from '../flows/AppliedFlowDescription.react';
import AppPanel from '../fw/AppPanel.react';
import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';
import urlMapping from '../app/URLMapping';
import types from '../../common/model-api/types';
import * as Tool from '../fw/Tool';
import {Button, Alert} from 'react-bootstrap';

import {scenarioRequiresPayPlan} from '../../common/model-api/ScenarioType';
import {FormattedMessage, injectIntl, IntlShape} from 'react-intl';
import {wrapNotFound} from '../app/NotFoundHandler.react';
import ApplyScenarioMutation from './ApplyScenarioMutation.react';
import ScenarioBoxAsWizard from '../scenarios/ScenarioBoxAsWizard.react';
import ScenarioIcon from '../scenarios/ScenarioIcon.react';
import {getLastOrganisationId} from '../app/LastOrganisationId';
import ChannelIcon from "../channel-defs/ChannelIcon.react";
import config from '../../common/config';
import {getExtensionURL, sendToExtension, isExtensionPresent} from '../app/ExtensionCommunicate';
import {LoadingLine} from '../loadingLine/renderLoadingPanel.react';
import EventTracker from '../app/EventTracker';
import mutationError from '../channel-defs/mutationError';
import StepperList from '../elements/StepperList.react';
import DetailBox from '../fw/DetailBox.react';
import meQuery from '../queries/MeQuery';
import FlowConfig from '../flows/FlowConfig.react';
import ChannelChooser from './ScenarioChooser.react';
import ScenarioChannelConnect from './ScenarioChannelConnect.react';
import ScenarioPrerequisite from './ScenarioPrerequisite.react';
import Link from 'react-router/lib/Link';

import './Scenario.scss';
import { User } from '../../common/types/types';

interface ScenarioApplyProps {
 intl: IntlShape;
 relay: object;
 user: User;
}

export class ScenarioApply extends React.Component<ScenarioApplyProps> {

    typeName = 'scenarios';

    static propTypes = {
        intl: PropTypes.object.isRequired,
        relay: PropTypes.object.isRequired,
        user: PropTypes.object.isRequired
    };

    static contextTypes = {
        router: PropTypes.object
    };

    constructor(props) {
        super(props);

        let scenario = this.getScenario();
        let channels = this.props.user.organisation.channels;

        let {alreadyConnectedChannels, channelsToConnect} = this.getChannelsToConnect(scenario, channels);

        this.state = {
            wasSuccess: false,
            flowSettingNeeded: false,
            flow: null,
            selectedChannels: [],
            channelSelect: {},
            isSaving: false,
            errors: null,
            configurationStep: ScenarioPrerequisite.show(channelsToConnect) ? 0 : alreadyConnectedChannels.filter(item => item.channelDef.canBeAddedOnce).length,
            activatingChannelId: null,
            alreadyConnectedChannels: alreadyConnectedChannels,
            channelsToConnect: channelsToConnect,
            resultLinks: [],
            scenario: scenario,
            channelsToSelect: ScenarioApply.getChannelsToSelect(scenario, channels),
            channelsWithConfidentialMode: ScenarioApply.getChannelsWitConfidentialMode(scenario, channels),
            loading: true,
        };

        // let some time to detect (not)installed extenstion
        setTimeout(() => {
            this.configurationSteps = this.getConfigurationSteps();

            this.setState({
                loading: false
            });
        }, 50);
    }

    onApplyScenarioClick(props) {
        this.setState({
            isSaving: true
        });

        if (!props.user.organisation) {
            return;
        }

        let scenario = props.user.scenario;

        if (!scenario) {
            scenario = props.user.scenarios.edges[0].node;
        }

        if (!scenarioRequiresPayPlan(scenario, props.user.organisation.payPlan)) {
            return;
        }

        EventTracker.trackEvent(EventTracker.EVENT_CLICKS, {
            event: 'scenario-apply',
            type: 'application'
        });

        return new Promise((resolve, reject) => {
            let onFailure = (transaction) => {
                mutationError(transaction);

                reject();
            };

            let onSuccess = (response) => {
                let {resultLinks, flows, errors} = response.applyScenario;
                let hasFlow = flows && flows.length > 0;

                if (errors) {
                    return this.setState({
                        isSaving: false,
                        errors: errors
                    });
                }

                sendToExtension({
                    message: 'dativery-reload'
                });

                if (hasFlow) {
                    this.props.relay.setVariables({
                        flowId: flows[0].realId
                    });
                }

                this.setState({
                    isSaving: false,
                    wasSuccess: true,
                    resultLinks: resultLinks || [],
                    flow: hasFlow ? flows[0] : null
                });

                resolve();

                props.relay.forceFetch();
            };

            Relay.Store.commitUpdate(new ApplyScenarioMutation({
                    scenario: scenario,
                    organisation: props.user.organisation,
                    selectedChannels: Object.keys(this.state.channelSelect).map((key) => {
                        return {
                            channelDef_id: key,
                            channel_id: this.state.channelSelect[key].realId
                        };
                    })}),
                {
                    onFailure,
                    onSuccess
                }
            );
        });

    }

    onChannelSelect(channelDef, channel) {
        let channelSelect = this.state.channelSelect;
        channelSelect[channelDef.realId] = channel;
        this.setState({channelSelect: channelSelect});
    }

    nextStep() {
        this.setState({
            configurationStep: this.state.configurationStep + 1
        });
    }

    getTitle(scenario) {
        const metadata = types[this.typeName];

        let title = Tool.getDataForColumn('title', metadata.fields(), scenario);
        if (!title) {
            title = Tool.getDataForColumn('name', metadata.fields(), scenario);
        }

        return title;
    }

    getScenario() {
        let scenario = this.props.user.scenario;

        if (!scenario) {
            scenario = this.props.user.scenarios.edges[0].node;
        }

        return scenario;
    }

    renderResultLinks() {
        return (
            <div>
                {this.state.resultLinks.length ? <h4><FormattedMessage defaultMessage="Do you want to see the scenario in action?" id="channelWizard.links.title" /></h4> : null}
                <div className={"scenario-apply-links" + (this.props.user.organisation.flow ? ' withFlow' : '')}>
                {this.state.resultLinks.map((resultLink, idx) => {
                    if (!resultLink.url) {
                        return (
                            <div className="scenario-apply-one" key={idx}>
                                <div className="title">
                                    <FormattedMessage defaultMessage="Open {channelDefName} and go to {sourceDefName}" id="channelWizard.links.name" values={{channelDefName: resultLink.channelDef.name, sourceDefName: resultLink.sourceDef.name}} />
                                </div>
                            </div>
                        );
                    } else if (resultLink.linksToSourceDef) {
                        return (
                            <div className="scenario-apply-one" key={idx}>
                                <div className="title">
                                    <a className="btn btn-default" href={resultLink.url} target="_blank">
                                        <ChannelIcon channelDef={resultLink.channelDef} size={32}/>{" "}
                                        <FormattedMessage defaultMessage="Open {channelDefName} and go to {sourceDefName}" id="channelWizard.links.name" values={{channelDefName: resultLink.channelDef.name, sourceDefName: resultLink.sourceDef.name}} />
                                    </a>
                                </div>
                            </div>
                        );
                    } else {
                        return (
                            <div className="scenario-apply-one" key={idx}>
                                <div className="title">
                                    <FormattedMessage defaultMessage="Open {channelDefName} and go to {sourceDefName}" id="channelWizard.links.name" values={{channelDefName: resultLink.channelDef.name, sourceDefName: resultLink.sourceDef.name}} />
                                </div>
                                <div className="action">
                                    <a className="btn btn-default" href={resultLink.url} target="_blank">
                                        <ChannelIcon channelDef={resultLink.channelDef} size={32}/>{" "}
                                        <FormattedMessage defaultMessage="Go to {channelDefName}" id="channelWizard.links.actionGo" values={{channelDefName: resultLink.channelDef.name}} /></a>
                                </div>
                            </div>
                        );
                    }
                })}

                {this.props.user.organisation.flow ?
                    <div className="scenario-flow-results">
                        <h4><FormattedMessage defaultMessage="Scenario is activated." id="channelWizard.scenaioActivated" /></h4>
                        {this.props.user.organisation.flow.flowDef && this.props.user.organisation.flow.flowDef.appliedDescription ? <div className="secondStepper">
                            <h4><FormattedMessage defaultMessage="How to use this flow scenario:" id="channelWizard.flowUsage.title" /></h4>
                            <AppliedFlowDescription flow={this.props.user.organisation.flow} user={this.props.user} />
                        </div> : null}

                        <p><Link className="btn btn-primary" to={urlMapping.getUrl(types['flows'], "view", this.props.user.organisation.flow)}><FormattedMessage defaultMessage="Go to flow detail" id="channelWizard.flowUsage.toDetail" /></Link></p>
                    </div>
                : null}
                </div>
            </div>
        );
    }

    renderChannelChoosers() {
        let channelGroups = [];
        let chanenlGroupKeys = {};

        this.state.channelsToSelect.forEach((item) => {
            let {channelSelect, channelsWithConfidentialMode} = this.state;

            item.isActive = Boolean(channelSelect[item.channelDef.realId] && channelSelect[item.channelDef.realId].id === item.id);
            item.hasError = channelsWithConfidentialMode ? channelsWithConfidentialMode.find(channelWithError => item.id === channelWithError.id) : false;

            if (chanenlGroupKeys[item.channelDef.realId] !== undefined) {
                channelGroups[chanenlGroupKeys[item.channelDef.realId]].channels.push(item);
                return;
            }

            chanenlGroupKeys[item.channelDef.realId] = channelGroups.length;
            let chanenlGroup = {
                channels: [item],
                channelDef: item.channelDef
            };
            channelGroups.push(chanenlGroup);
        });

        // Sort by order field
        channelGroups.sort((groupA, groupB) => {
            let groupAOrder = this.state.scenario.scenarios2ChannelDefs.edges.find(({node}) => node.channelDef.realId === groupA.channelDef.realId).order;
            let groupBOrder = this.state.scenario.scenarios2ChannelDefs.edges.find(({node}) => node.channelDef.realId === groupB.channelDef.realId).order;

            return groupAOrder - groupBOrder;
        });

        return channelGroups.map((channelGroup, index) => {
            return {
                title: (<FormattedMessage defaultMessage="Select {app} from multiple connections" id="channelWizard.selectApplicationTitle" values={{app: channelGroup.channelDef.name}} />),
                description: (
                    <ChannelChooser
                        channelGroup={channelGroup}
                        connectCallback={(channel) => {
                            this.connectChannelStep4Callback(channel);
                        }}
                        nextStep={() => { return this.nextStep(); }}
                        onChannelSelect={(channelDef, channel) => { return this.onChannelSelect(channelDef, channel); }}
                        scenario={this.state.scenario}
                    />
                )
            };
        });
    }

    renderConfidentialChannels() {
        let confidentialChannelsCount = this.state.channelsWithConfidentialMode.length;

        return (
            <div>
                <p>
                    <FormattedMessage defaultMessage="Scenario requires data caching but confidential mode preventing data caching is activated on {count, plural, one {this channnel} few {these channnels} other {these channnels}}:" id="scenarioApply.chaching.channelsHeader" values={{count: confidentialChannelsCount}} />
                </p>
                <div className="channelsWithConfidentialMode">
                    {
                        this.state.channelsWithConfidentialMode.map((channel, idx) => {
                            return (<div key={idx}>
                                <ChannelIcon channelDef={channel.channelDef} size={32}/>&nbsp;{channel.name ? channel.name : channel.channelDef.name}
                            </div>);
                        })
                    }
                </div>
                <div>
                    <Button className="btn btn-primary" onClick={() => {this.nextStep();}}>
                        <FormattedMessage defaultMessage="Disable confidential mode" id="channel.disableConfidential" />
                    </Button>
                </div>
            </div>
        );
    }

    renderFlowSettings(activeStep) {
        if (!activeStep) {
            return;
        }

        if (!this.finalSaving && !this.state.errors) {
            this.finalSaving = true;
            this.onApplyScenarioClick(this.props);
        }

        if (this.state.isSaving) {
            return (
                <LoadingLine withMessage>
                    <FormattedMessage defaultMessage="Activating scenario…" id="scanarioActivation.message" />
                </LoadingLine>
            );
        }

        if (this.state.errors) {
            return this.renderError();
        }

        if (this.state.flow) {
            try {
                let configOptions = JSON.parse(this.state.flow.configOptions);
                if (Object.keys(configOptions).length === 0) {
                    return this.nextStep();
                }
            } catch (e) {
                /* ignore error */
            }

            const queryConfig = {
                queries: meQuery,
                name: 'User',
                params: {
                    organisationId: this.props.user.organisation.realId,
                    scenarioId: this.state.scenario.realId,
                    flowId: this.state.flow.realId
                }
            };

            return (<Relay.Renderer
                Container={FlowConfig}
                environment={Relay.Store}
                queryConfig={queryConfig}
                render={(state) => {
                    if (state.done && this.step !== this.state.configurationStep) {
                        this.step = this.state.configurationStep;
                        return (<FlowConfig {...state.props} createCallback={(channel) => {this.nextStep();}} createStep wrapper />);
                    }
                    else if (!state.done) {
                        return (<LoadingLine withMessage>
                            <FormattedMessage defaultMessage="Loading flow settings…" id="scanarioActivation.loadingFlowSettings" />
                        </LoadingLine>);
                    }
                }}
            />);
        } else {
            return (<FormattedMessage defaultMessage="Scenario could not be applied because of a missing flow. If the issue persists, please try again later" id="scenarioApply.couldNotApplyMissingFlow"/>);
        }
    }

    getChannelsToConnect(scenario, channels) {
        let scenarioChannelDefs = scenario.scenarios2ChannelDefs.edges.map(({node}) => node.channelDef.realId);

        let channelGrouped = {};
        channels.edges.forEach(({node}) => {
            let chanenlDefId = node.channelDef.realId;

            if (!channelGrouped[chanenlDefId]) {
                channelGrouped[chanenlDefId] = [];
            }

            channelGrouped[chanenlDefId].push(node);
        });

        let channelsToConnect = [];
        let alreadyConnectedChannels = [];

        scenarioChannelDefs.forEach((channelDefId) => {
            if (!channelGrouped[channelDefId]) {
                channelsToConnect.push({
                    channelDef: scenario.scenarios2ChannelDefs.edges.find((channel) => channel.node.channelDef.realId === channelDefId).node.channelDef
                });
            }
            else if (channelGrouped[channelDefId].length === 1) {
                alreadyConnectedChannels.push(channelGrouped[channelDefId][0]);
            }
        });

        return {
            alreadyConnectedChannels: alreadyConnectedChannels.sort((channelA, channelB) => {
                    if (channelA.channelDef.canBeAddedOnce && channelB.channelDef.canBeAddedOnce) {
                        let channelAOrder = scenario.scenarios2ChannelDefs.edges.find(({node}) => node.channelDef.realId === channelA.channelDef.realId).order;
                        let channelBOrder = scenario.scenarios2ChannelDefs.edges.find(({node}) => node.channelDef.realId === channelB.channelDef.realId).order;

                        return channelAOrder - channelBOrder;
                    }

                    if (channelA.channelDef.canBeAddedOnce) {
                        return -1;
                    }

                    if (channelB.channelDef.canBeAddedOnce) {
                        return 1;
                    }


                    let channelAOrder = scenario.scenarios2ChannelDefs.edges.find(({node}) => node.channelDef.realId === channelA.channelDef.realId).order;
                    let channelBOrder = scenario.scenarios2ChannelDefs.edges.find(({node}) => node.channelDef.realId === channelB.channelDef.realId).order;

                    return channelAOrder - channelBOrder;
            }),
            channelsToConnect: channelsToConnect.sort((channelA, channelB) => {
                let channelAOrder = scenario.scenarios2ChannelDefs.edges.find(({node}) => node.channelDef.realId === channelA.channelDef.realId).order;
                let channelBOrder = scenario.scenarios2ChannelDefs.edges.find(({node}) => node.channelDef.realId === channelB.channelDef.realId).order;

                return channelAOrder - channelBOrder;
            })
        };
    }

    static getChannelsToSelect(scenario, channels) {
        let scenarioChannelDefs = scenario.scenarios2ChannelDefs.edges.map(({node}) => node.channelDef.realId);

        let channelGrouped = {};
        channels.edges.forEach(({node}) => {
            let chanenlDefId = node.channelDef.realId;

            if (!channelGrouped[chanenlDefId]) {
                channelGrouped[chanenlDefId] = [];
            }

            channelGrouped[chanenlDefId].push(node);
        });

        let channelsToSelect = [];
        Object.keys(channelGrouped).forEach(groupId => {
            if (scenarioChannelDefs.includes(groupId) && channelGrouped[groupId].length > 1) {
                channelGrouped[groupId].forEach((channel) => {
                    channelsToSelect.push(channel);
                });
            }
        });

        return channelsToSelect.sort((channelA, channelB) => {
            let channelAOrder = scenario.scenarios2ChannelDefs.edges.find(({node}) => node.channelDef.realId === channelA.channelDef.realId).order;
            let channelBOrder = scenario.scenarios2ChannelDefs.edges.find(({node}) => node.channelDef.realId === channelB.channelDef.realId).order;

            return channelAOrder - channelBOrder;
        });
    }

    static getChannelsWitConfidentialMode(scenario, channels) {
        if (!scenario.requiresCaching) {
            return [];
        }

        let scenarioChannelDefs = scenario.scenarios2ChannelDefs.edges.map(({node}) => node.channelDef.realId);

        let channelGrouped = {};
        let channelsWithConfidentialMode = [];

        channels.edges.forEach(({node}) => {
            let chanenlDefId = node.channelDef.realId;

            if (!channelGrouped[chanenlDefId]) {
                channelGrouped[chanenlDefId] = [];
            }

            channelGrouped[chanenlDefId].push(node);

            Object.keys(channelGrouped).forEach(groupId => {
                if (scenarioChannelDefs.includes(groupId) && channelGrouped[groupId].length === 1 && channelGrouped[groupId][0].confidential) {
                    channelGrouped[groupId].forEach((channel) => {
                        channelsWithConfidentialMode.push(channel);
                    });
                }
            });
        });

        return channelsWithConfidentialMode;
    }

    static showFlowSettings(scenario) {
        if (!scenario.scenarioDef.scenarioFlowDefs || !scenario.scenarioDef.scenarioFlowDefs.edges || 0 === scenario.scenarioDef.scenarioFlowDefs.edges.length) {
            return false;
        }

        let flowsWithSettings = scenario.scenarioDef.scenarioFlowDefs.edges.filter(({node}) => !Boolean(node.hideFlowSettingsDuringScenarioApply));

        return flowsWithSettings.length > 0;
    }

    connectChannelStep4Callback(channel) {
        let nextStep = this.state.configurationStep + 1;

        this.onChannelSelect(channel.channelDef, channel);

        // NOTE: forceFetch callback could be called multiple times on one invocation
        this.props.relay.forceFetch({}, () => {
            let scenario = this.getScenario();
            let channels = this.props.user.organisation.channels;

            let {alreadyConnectedChannels, channelsToConnect} = this.getChannelsToConnect(scenario, channels);

            this.setState({
                configurationStep: nextStep,
                alreadyConnectedChannels: alreadyConnectedChannels,
                channelsToConnect: channelsToConnect,
                channelsToSelect: ScenarioApply.getChannelsToSelect(scenario, channels),
            });
        });
    }

    renderChannelsToConnect() {
        let channelsToConnect = this.state.channelsToConnect;

        if (channelsToConnect.length === 0 && this.state.alreadyConnectedChannels.length <= 0) {
            return [];
        }

        let channelsToConnectRender = [];

        channelsToConnect.forEach((item, index) => {
            channelsToConnectRender.push({
                title: (<FormattedMessage defaultMessage="Connect {applicationName}" id="channelWizard.connectApplicationName" values={{applicationName: item.channelDef.name}} />),
                description: (<ScenarioChannelConnect
                    channelDef={item.channelDef}
                    connectCallback={(channel) => {
                        return this.connectChannelStep4Callback(channel);
                    }}
                    scenario={this.state.scenario}
                />)
            });
        });

        return channelsToConnectRender;
    }

    renderAlreadyConnectedChannels() {
        return this.state.alreadyConnectedChannels.map((item) => {
            return {
                finished: true,
                title: (<FormattedMessage defaultMessage="Connected {applicationName}" id="channelWizard.connectedApplicationName" values={{applicationName: item.channelDef.name}} />),
                description: (
                    <ChannelChooser
                        channelGroup={{
                            channels: [item],
                            channelDef: item.channelDef
                        }}
                        connectCallback={(channel) => {
                            return this.connectChannelStep4Callback(channel);
                        }}
                        nextStep={() => { return this.nextStep(); }}
                        onChannelSelect={(channelDef, channel) => { return this.onChannelSelect(channelDef, channel); }}
                        scenario={this.state.scenario}
                    />
                )
            };
        });
    }

    renderError() {
        return (
            <Alert bsStyle="danger">
                <FormattedMessage defaultMessage="Error during scenario apply: {message}" id="channelWizard.apply.error" values={{message: (<strong>{this.state.errors}</strong>)}} />
            </Alert>
        );
    }

    renderFinishStep(finalStep) {
        if (!finalStep) {
            return;
        }

        if (!this.finalSaving && !this.state.errors) {
            this.finalSaving = true;
            this.onApplyScenarioClick(this.props);
        }

        if (this.state.isSaving) {
            return (
                <LoadingLine withMessage>
                    <FormattedMessage defaultMessage="Activating scenario…" id="scanarioActivation.message" />
                </LoadingLine>
            );
        }

        if (this.state.errors) {
            return this.renderError();
        }

        return this.renderResultLinks();
    }

    getDestinationChannelDef() {
        let destinationDefs = this.state.scenario.scenarios2ChannelDefs.edges.filter(({node}) => node.ruleType === 'destination');

        if (destinationDefs.length === 0) {
            return false;
        }

        try {
            return destinationDefs[0].node.channelDef;
        }
        catch (e) {
            return false;
        }
    }

    needInstallExtensionStep() {
        let destinationChannelDef = this.getDestinationChannelDef();

        if (!Boolean(destinationChannelDef)) {
            return false;
        }

        if (this.state.scenario.requiresExtension === false) {
            return false;
        }

        let hasOwnPlugin = Boolean(destinationChannelDef.hasOwnPlugin);

        return !hasOwnPlugin && !isExtensionPresent();
    }

    renderInstallExtenstionStep() {
        let destinationChannelDef = this.getDestinationChannelDef();

        return (
            <div>
                <ChannelIcon channelDef={destinationChannelDef} size={32}/>{" "}<FormattedMessage defaultMessage="To use {channelDefName} with {productName} you must" id="channelWizard.extensionRequired" values={{channelDefName: destinationChannelDef.name, productName: config.PRODUCT_NAME}} />
                {" "}<a className="btn btn-primary" href={getExtensionURL()} onClick={() => {this.nextStep();}} target="_blank">
                    <FormattedMessage defaultMessage="install our Browser Extension" id="channelWizard.extensionRequiredButton" />
                </a>.
                <br /><br />
                <a className="btn btn-primary" href="#" onClick={() => { this.nextStep(); return false;}}>
                    <FormattedMessage defaultMessage="Next step" id="channelWizard.skipStep" />
                </a>
            </div>
        );
    }

    // renderConnectRequirements() {
    // 	let destinationChannelDef = this.getDestinationChannelDef();

    // 	if (!Boolean(destinationChannelDef) || !Boolean(destinationChannelDef.connectRequirement)) {
    // 		return null;
    // 	}

    // 	return (<div>
    // 		<ChannelIcon channelDef={destinationChannelDef} size={32}/>{" "}{Tool.getFormatted(types['channelDefs'], 'connectRequirement', this.props.intl.formatMessage, destinationChannelDef)}
    // 		<br /><br />
    // 		<a className="btn btn-primary" href="#" onClick={() => { this.nextStep(); return false;}}>
    // 			<FormattedMessage defaultMessage="Next step" id="channelWizard.skipStep" />
    // 		</a>
    // 	</div>);
    // }

    getConfigurationSteps() {
        let configurationList = [];
        let showFlowSettings = ScenarioApply.showFlowSettings(this.state.scenario);

        if (this.state.alreadyConnectedChannels.length > 0) {
            configurationList.push(...this.renderAlreadyConnectedChannels());
        }

        configurationList.push(...this.renderChannelsToConnect());

        if (this.state.channelsToSelect.length > 0) {
            configurationList.push(...this.renderChannelChoosers());
        }

        if (this.state.channelsWithConfidentialMode.length > 0) {
            configurationList.push({
                title: (<FormattedMessage defaultMessage="Confidential mode notice" id="channelWizard.confidentialModeNotice" />),
                description: this.renderConfidentialChannels()
            });
        }

        if (showFlowSettings) {
            configurationList.push({
                title: (<FormattedMessage defaultMessage="Flow settings" id="channelWizard.flowSettingsTitle" />),
                description: this.renderFlowSettings(configurationList.length === this.state.configurationStep)
            });
        }

        if (this.needInstallExtensionStep()) {
            configurationList.push({
                title: (<FormattedMessage defaultMessage="Browser extension" id="channelWizard.installBrowserExtension" />),
                description: this.renderInstallExtenstionStep()
            });
        }

        //
        // let connectRequirements = this.renderConnectRequirements();
        // if (connectRequirements) {
        // 	configurationList.push({
        // 		title: (<FormattedMessage defaultMessage="Connect requirements" id="channelWizard.connectRequirements" />),
        // 		description: connectRequirements
        // 	});
        // }

        configurationList.push({
            title: (<FormattedMessage defaultMessage="Activation finished" id="channelWizard.activationFinished" />),
            description: this.renderFinishStep(configurationList.length === this.state.configurationStep)
        });

        return configurationList;
    }

    render() {
        let {scenario} = this.state;
        let type = types[this.typeName];
        let title = this.getTitle(scenario);

        if (this.state.loading) {
            return null;
        }

        this.configurationSteps = this.getConfigurationSteps();

        return (
            <AppPanel breadcrumbParams={[
                {type, data: scenario},
                {type: types['scenarios'], data: scenario},
                {type: types['organisations'], data: this.props.user.organisation}
            ]} className="scenarioWizzardNew" title={title}>

                <DetailBox className="scenarioWizard" data={scenario.scenarioDef} metadata={type} urlMapping={urlMapping}>
                    <div className="scenario-header">
                        <div className="left">
                            <ScenarioIcon scenario={scenario} />
                        </div>
                        <div className="main" style={{padding: '0'}}>
                            <span className="flex"></span>
                            <h2><FormattedMessage defaultMessage="Scenario activation" id="channelWizard.activationHeader" /></h2>
                            <span className="flex"></span>
                        </div>
                    </div>
                </DetailBox>

                <StepperList activeStep={this.state.configurationStep} list={this.configurationSteps} />
            </AppPanel>
        );
    }
}

export default Relay.createContainer(wrapNotFound(injectIntl(ScenarioApply), (props) => {
    return (props.user.scenarios && props.user.scenarios.edges.length) > 0 || props.user.scenario;
}), {
    initialVariables: {
        scenarioUrlFragment: '',
        scenarioUrlFragmentSelected: false,
        scenarioId: '',
        scenarioIdSelected: false,
        organisationId: '',
        organisationSelected: false,
        flowId: '',
        flowSelected: false,
    },
    prepareVariables (variables) {
        if (!variables.organisationId) {
            variables.organisationId = getLastOrganisationId();
        }

        variables['organisationSelected'] = variables['organisationId'] ? true : false;
        variables['flowSelected'] = variables['flowId'] ? true : false;
        variables['scenarioUrlFragmentSelected'] = variables['scenarioUrlFragment'] ? true : false;
        variables['scenarioIdSelected'] = variables['scenarioId'] ? true : false;

        return variables;
    },
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                firstname,
                surname,
                email,
                ${AppliedFlowDescription.getFragment('user')}
                organisation(id: $organisationId) @include(if: $organisationSelected) {
                    id,
                    realId,
                    name,
                    payPlan,
                    ${ScenarioBoxAsWizard.getFragment('organisation')},
                    channels(first: 1000, deleted: false) {
                        edges {
                            node {
                                name,
                                type,
                                confidential,
                                cachingStatus,
                                activated,
                                metadata,
                                lockedAdding,
                                channelDef {
                                    id,
                                    realId,
                                    icon,
                                    addType,
                                    name,
                                    state,
                                    hasOwnPlugin,
                                    metadata,
                                    canBeAddedOnce
                                },
                                id,
                                realId,
                                organisation_id,
                            }
                        },
                    },
                    flow(id: $flowId) @include(if: $flowSelected) {
                        id,
                        realId,
                        organisation_id,
                        configOptions,
                        flowDef {
                            id,
                            realId,
                            appliedDescription,
                        }
                        ${AppliedFlowDescription.getFragment('flow')}
                    },
                    usedScenariosByURL(urlFragment: $scenarioUrlFragment, first: 10) @include(if: $scenarioUrlFragmentSelected) {
                        edges {
                            node {
                                id,
                                realId,
                                scenario_id,
                                scenarioDef_id,
                            }
                        }
                    },
                },
                organisations(first: 10) {
                    edges {
                        node {
                            id,
                        }
                    }
                },
                scenarios(first: 1, urlFragment: $scenarioUrlFragment) @include(if: $scenarioUrlFragmentSelected) {
                    edges {
                        node {
                            id,
                            realId,
                            name,
                            title,
                            description,
                            urlFragment,
                            requiresCaching,
                            requiresExtension,
                            scenarioDef {
                                scenarioFlowDefs(first: 100) {
                                    edges {
                                        node {
                                            realId
                                        }
                                    }

                                }
                            }
                            scenarios2ChannelDefs(first: 100) {
                                edges {
                                    node {
                                        id,
                                        realId,
                                        ruleType,
                                        order,
                                        channelDef {
                                            id,
                                            realId,
                                            name,
                                            icon,
                                            metadata,
                                            hasOwnPlugin,
                                            connectRequirement,
                                            requiresAgent,
                                            canBeAddedOnce
                                        }
                                    }
                                }
                            }
                            ${ScenarioBoxAsWizard.getFragment('scenario')},
                            ${ScenarioIcon.getFragment('scenario')}
                        }
                    }
                },
                scenario(id: $scenarioId) @include(if: $scenarioIdSelected) {
                    id,
                    realId,
                    name,
                    title,
                    description,
                    urlFragment,
                    requiresCaching,
                    requiresExtension,
                    scenarioDef {
                        scenarioFlowDefs(first: 100) {
                            edges {
                                node {
                                    realId,
                                    hideFlowSettingsDuringScenarioApply
                                }
                            }

                        }
                    },
                    scenarios2ChannelDefs(first: 100) {
                        edges {
                            node {
                                id,
                                realId,
                                ruleType,
                                order,
                                channelDef {
                                    id,
                                    realId,
                                    name,
                                    icon,
                                    metadata,
                                    hasOwnPlugin,
                                    connectRequirement,
                                    requiresAgent,
                                    canBeAddedOnce
                                }
                            }
                        }
                    }
                    ${ScenarioBoxAsWizard.getFragment('scenario')},
                    ${ScenarioIcon.getFragment('scenario')}
                },
            }
        `,
    },
});
